import type { RecurrencesMap } from '../../typings'

import { Calendar } from './components/Calendar'

import { useMonthlyCalendarProps } from './useMonthlyCalendarProps'

type Props = {
  recurrenceMap: RecurrencesMap
  onChange: (date: Date) => void
  date: Date | null
}

export function MonthlyCalendar(props: Props) {
  const { recurrenceMap, onChange, date } = props
  const calendarProps = useMonthlyCalendarProps(recurrenceMap, onChange, date)

  return <Calendar {...calendarProps} />
}
